import React, { ComponentProps } from 'react'

type ImgIconComponent<Props = Record<string, unknown>> = React.VFC<Props & React.ComponentProps<'img'>>
type CustomIconMapType = Record<string, { img?: string }>

export const CustomIconMap: CustomIconMapType = {
  google: {
    img: '/icons/google.svg',
  },
  apple: {
    img: '/icons/apple.svg',
  },
  facebook: {
    img: '/icons/facebook.svg',
  },
} as const

export type IconCodeType = keyof typeof CustomIconMap

export type CustomIconProps = {
  iconCode: IconCodeType;
}

export const CustomIcon: React.FC<CustomIconProps> = ({ iconCode, ...props }) => {
  const Icon = CustomIconMap[iconCode]

  // eslint-disable-next-line
  return Icon?.img ? (
    <img src={Icon.img} alt="" {...(props as ComponentProps<ImgIconComponent>)} />
  ) : null
}
